import State from "@/lib/hey";

import { getWebglValues } from "@/modules/webgl";

export default function webglReceiver(element, dataset) {
  // console.log("webglReceiver initialized", element, dataset);
  const parent = element.parentElement;
  element.remove();

  let canvasInParent = false;

  // Create intersection observer to detect when parent is in view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          getWebglValues(dataset);

          // Only append canvas if it's not already in the parent
          if (
            !canvasInParent &&
            window.WEBGL_CANVAS &&
            !parent.querySelector("canvas")
          ) {
            parent.appendChild(window.WEBGL_CANVAS);
            canvasInParent = true;
          }

          State.CANVAS_CONTAINER = element;
        } else {
          // Remove canvas when parent goes out of view
          if (
            canvasInParent &&
            window.WEBGL_CANVAS &&
            window.WEBGL_CANVAS.parentElement === parent
          ) {
            window.WEBGL_CANVAS.remove();
            canvasInParent = false;
          }
        }
      });
    },
    {
      // Optional: configure threshold and root margin
      threshold: 0.01, // Trigger when 10% of element is visible
      rootMargin: "0px", // No margin around the root
    }
  );

  // Start observing the parent element
  observer.observe(parent);

  // Return cleanup function to disconnect observer
  return () => {
    observer.disconnect();
    // Clean up canvas if it's still in the parent
    if (
      canvasInParent &&
      window.WEBGL_CANVAS &&
      window.WEBGL_CANVAS.parentElement === parent
    ) {
      window.WEBGL_CANVAS.remove();
    }
  };
}
